import Cookie from "js-cookie";
import { useEffect, useCallback } from "react";

import {
  EVIDON_GDPR_CONSENT_COOKIE,
  EVIDON_SUPPRESS_GDPR_NOTIFICATION_COOKIE,
  EVIDON_CONSENT_DECLINE_EXPIRATION_DAYS,
} from "../constants";

const EvidonConsentHotfix = () => {
  const priorConsentCallback = useCallback(() => {
    const cookieValue = JSON.stringify({ date: new Date() });
    const cookiePath = window.evidon.notice._getConsentCookieDomainPath();
    const cookieDomain = window.evidon.notice._getConsentCookieDomain();
    const cookieExpireDate = new Date();

    cookieExpireDate.setDate(
      cookieExpireDate.getDate() + EVIDON_CONSENT_DECLINE_EXPIRATION_DAYS
    );

    window.evidon.notice._writeCookie(
      EVIDON_SUPPRESS_GDPR_NOTIFICATION_COOKIE,
      cookieValue,
      cookieExpireDate.toUTCString(),
      cookiePath,
      cookieDomain
    );
  }, []);
  useEffect(() => {
    // Override the original `_isConsentGiven` method
    // to explicitly check if the consent cookie is applied to GDPR
    window.evidon.notice._isConsentGiven = () =>
      Boolean(Cookie.get(EVIDON_GDPR_CONSENT_COOKIE));

    // Override the original `_getSuppressionCookie` method
    // to explicitly check if the suppression cookie is applied to GDPR
    window.evidon.notice._getSuppressionCookie = () =>
      Boolean(Cookie.get(EVIDON_SUPPRESS_GDPR_NOTIFICATION_COOKIE));

    // Show the consent notice only if necessary
    window.evidon.notice.showNotice();

    window.evidon.notice.consentCallbackExecuted = false;

    window.evidon.priorConsentCallback = priorConsentCallback;
  }, []);

  return null;
};

export default EvidonConsentHotfix;
